// Shared status color map for the TI requirement workflow (GenDefinitionDetail DefID 1721).
// 1 Nuevo, 2 En Refinamiento, 3 Listo para Desarrollo, 4 En Desarrollo,
// 5 En QA, 6 En UAT, 7 Listo para Producción, 8 En Producción, 9 Cancelado.
const statusColors = {
  1: "blue",
  2: "amber darken-2",
  3: "deep-purple",
  4: "teal darken-1",
  5: "cyan darken-2",
  6: "green darken-1",
  7: "light-green darken-2",
  8: "green darken-4",
  9: "red darken-2"
};

export function statusColor(status) {
  return statusColors[status] || "blue-grey";
}

// Fibonacci mapping of story size (def 1724: 1 XS .. 5 XL) to story points.
export const pointsMap = { 1: 1, 2: 2, 3: 3, 4: 5, 5: 8 };

// Score chip colors used in the prioritization grid and modal.
export function getScoreColor(score) {
  if (score == null || score === 0) return "grey";
  if (score >= 80) return "green darken-1";
  if (score >= 60) return "light-green darken-1";
  if (score >= 40) return "amber darken-2";
  if (score > 0) return "red darken-1";
  return "grey";
}
